/** @format */

import {styled} from '@mui/material/styles';
import {TableCell} from '@mui/material';

import {TableVariant} from '../../types';

interface StyledTableCellProps {
  width?: number;
  height?: number;
  sorted?: boolean;
  cellHeight: number;
  enableHoverExpand?: boolean;
  isExpandable?: boolean;
  isWithSubRows?: boolean;
  canSort?: boolean;
  tableVariant?: TableVariant;
  verticalAlign?: 'middle' | 'top';
  // Ширину колонки задаёт <col> из <colgroup> — у ячейки её быть не должно вообще.
  // Ни своей ширины, ни фолбэка `100%`: под table-layout: fixed браузер берёт максимум из
  // ширины <col> и ширины ячейки первой строки, поэтому любая ширина на ячейке не даёт
  // колонке сузиться.
  isWidthFromColgroup?: boolean;
}

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: prop =>
    prop !== 'sorted' &&
    prop !== 'cellHeight' &&
    prop !== 'enableHoverExpand' &&
    prop !== 'isExpandable' &&
    prop !== 'canSort' &&
    prop !== 'isWithSubRows' &&
    prop !== 'verticalAlign' &&
    prop !== 'isWidthFromColgroup' &&
    prop !== 'tableVariant',
})<StyledTableCellProps>(({
  theme,
  width,
  height,
  sorted,
  cellHeight,
  enableHoverExpand,
  isExpandable,
  isWithSubRows,
  canSort,
  tableVariant = 'dark',
  verticalAlign = 'top',
  isWidthFromColgroup,
}) => {
  const isLightVariant = tableVariant === 'light';
  const isHighlight = (enableHoverExpand && isExpandable) || canSort;

  const getBackgroundColor = () => {
    if (sorted) {
      return isLightVariant
        ? theme.palette.figma_gray_light_1?.main
        : theme.palette.figma_gray_dark_2?.main;
    }
    return 'none';
  };

  return {
    width: isWidthFromColgroup ? 'auto' : width ? `${width}px` : '100%',
    height: isWithSubRows ? 'auto' : height ? `${height}px` : `${cellHeight}px`,
    padding: theme.spacing(1.5, 4),
    borderBottom: 'none',
    backgroundColor: getBackgroundColor(),
    position: 'relative',
    overflow: 'hidden',
    verticalAlign,

    ...(isHighlight && {
      cursor: 'pointer',
      '&:hover': {
        background: isLightVariant
          ? theme.palette.semantic_light?.surface.surface1
          : theme.palette.figma_gray_dark_2?.main,
      },
    }),
  };
});
